// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file auth/get_user_access.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { PharmacyAccess } from "./common_pb.js";

/**
 * @generated from message com.neulink.pharmacy.GetUserAccessRequest
 */
export class GetUserAccessRequest extends Message<GetUserAccessRequest> {
  /**
   * @generated from field: string username = 1;
   */
  username = "";

  /**
   * @generated from field: string password = 2;
   */
  password = "";

  constructor(data?: PartialMessage<GetUserAccessRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.GetUserAccessRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "password", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetUserAccessRequest {
    return new GetUserAccessRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetUserAccessRequest {
    return new GetUserAccessRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetUserAccessRequest {
    return new GetUserAccessRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetUserAccessRequest | PlainMessage<GetUserAccessRequest> | undefined, b: GetUserAccessRequest | PlainMessage<GetUserAccessRequest> | undefined): boolean {
    return proto3.util.equals(GetUserAccessRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.GetUserAccessResponse
 */
export class GetUserAccessResponse extends Message<GetUserAccessResponse> {
  /**
   * @generated from field: repeated com.neulink.pharmacy.PharmacyAccess access = 1;
   */
  access: PharmacyAccess[] = [];

  constructor(data?: PartialMessage<GetUserAccessResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.GetUserAccessResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "access", kind: "message", T: PharmacyAccess, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetUserAccessResponse {
    return new GetUserAccessResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetUserAccessResponse {
    return new GetUserAccessResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetUserAccessResponse {
    return new GetUserAccessResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetUserAccessResponse | PlainMessage<GetUserAccessResponse> | undefined, b: GetUserAccessResponse | PlainMessage<GetUserAccessResponse> | undefined): boolean {
    return proto3.util.equals(GetUserAccessResponse, a, b);
  }
}

